// extracted by mini-css-extract-plugin
export var active = "_a7-c";
export var activeIndicator = "_a7-7";
export var animate = "_a7-b";
export var contentWidthTabs = "_a7-5";
export var disabled = "_a7-d";
export var flat = "_a7-1";
export var fullWidth = "_a7-3";
export var lg = "_a7-a";
export var md = "_a7-9";
export var redoButtonTabGroup = "_a7-0";
export var sm = "_a7-8";
export var tabButton = "_a7-4";
export var tabButtonsContainer = "_a7-2";
export var xs = "_a7-6";